<template>
  <div>
    <span>{{name}}</span>
  </div>
</template>

<script>
export default {
  name: 'CPrefecture',
  props: {
    name: {
      type: String,
      default: ''
    }
  }
}
</script>
